var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('RabbeyTable3',{attrs:{"data":_vm.items,"actions":_vm.IsPenging ? _vm.ActionPending : _vm.ActionTask,"columns":_vm.TaskColumns},on:{"rtable-push-action":_vm.handlerOpcion}}),_c('TaskForm',{ref:"taskForm",attrs:{"append-to-body":true},on:{"update":_vm.update}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }